<template>
  <v-dialog
      max-width="800px"
      :value="dialog"
      persistent
  >
    <v-card>
      <v-card-text>
        <v-card-title>
          {{ title }} мероприятия анкетирования
        </v-card-title>
        <v-form>
          <v-select
              v-model="worksheet.worksheetType"
              :items="worksheetTypes"
              item-value="id"
              item-text="name"
              label="Тип анкетирования" />
          <v-menu
              v-model="menu"
              ref="menu"
              :close-on-content-click="false"
              :return-value.sync="worksheet.date"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="worksheet.date"
                  label="Дата"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              />
            </template>
            <v-date-picker
                v-model="worksheet.date"
                no-title
                scrollable
                locale="ru"
            >
              <v-spacer></v-spacer>
              <v-btn
                  text
                  color="primary"
                  @click="menu = false"
              >
                Отмена
              </v-btn>
              <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(worksheet.date)"
              >
                ОК
              </v-btn>
            </v-date-picker>
          </v-menu>
<!--          d-flex - помогает ограничить чекбокс, чтобы нажатии обрабатывалось только при точном нажатии-->
          <div class="d-flex">
          <v-checkbox v-model="worksheet.isActual" label="Актуальное" />
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            outlined
            color="primary"
            @click="close"
        >
          Отмена
        </v-btn>
        <v-btn
            outlined
            color="primary"
            @click="save"
        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { dateMixin, dbMixin } from "@/mixins"

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Worksheet",
  mixins: [dbMixin, dateMixin],
  props: ['worksheetTypes'],
  data () {
    return {
      dialog: false,
      menu: false,
      mode: '',
      worksheet: {
        id: '',
        worksheetType: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        isActual: true
      }
    }
  },
  computed: {
    title () {
      return this.mode === 'add' ? 'Добавление' : 'Редактирование'
    }
  },
  methods: {
    myClick() {
      this.worksheet.isActual = !this.worksheet.isActual
    },
    close () {
      this.dialog = false
      this.clearFields()
    },
    clearFields () {
      this.worksheet.worksheetType = ''
      this.worksheet.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      this.worksheet.isActual = true
    },
    openAddEditDialog (item) {
      this.dialog = true
      if (item) {
        this.mode = 'edit'
        this.worksheet = { ...item }
        this.worksheet.date = this.pickerDate(this.worksheet.date)
      } else {
        this.mode = 'add'
      }
    },
    async save () {
      const url = `${process.env.VUE_APP_SERVER_URL}/mutation/worksheet`
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ mode: this.mode, ...this.worksheet }),
      });
      if (response.status == 200) {
        const action = this.mode === 'add' ? 'добавлен' : 'отредактирован'
        this.$dialog.notify.success(`Вебинар успешно ${action}`, { dismissible: false, timeout: 1000 })
        this.close()
        this.$emit('refetch')
      } else {
        await this.errorHandler(response, 'Ошибка обработки вебинара')
      }

    }
  }
}
</script>

<style scoped>

</style>